
import "../../assets/favicon-grey-24.png";
import "../../assets/btn_google_signin_dark_normal_web.png";

import get from "lodash-es/get";

import Vue from "vue";
import Component from "vue-class-component";

import { Prop } from "vue-property-decorator";

import {
  AUTHENTICATE_USER,
  FETCH_PIPELINES,
  SET_GLOBAL_SNACKBAR,
  SET_USER_PROFILE,
} from "../store";
import { WebAPI } from "../web-api";

import { Snackbar } from "../snackbar";

@Component({})
export default class LoginPage extends Vue {
  @Prop({ default: "/", type: String })
  public redirectPath: string;

  public login_form_username: string = "";
  public login_form_password: string = "";

  public showExternalButtons: boolean = true;

  public get is_authenticated(): boolean {
    return this.$store.getters.is_authenticated;
  }

  public get full_name(): string {
    return get(this.$store.state.user_profile, "full_name", "Anonymous");
  }

  public get username(): string {
    return get(this.$store.state.user_profile, "username", "anonymous");
  }

  public async created() {}

  public async login(provider: string) {
    let providerData = { provider: provider };
    if (provider === "laxy") {
      providerData = Object.assign(providerData, {
        username: this.login_form_username,
        password: this.login_form_password,
      });
    }
    try {
      await this.$store.dispatch(AUTHENTICATE_USER, providerData);
      await this.$store.dispatch(FETCH_PIPELINES);
      this.clearLoginForm();
      this.$router.push({ path: this.redirectPath });
    } catch (error) {
      if (error.message === "Auth popup window closed") {
        Snackbar.flashMessage("Authentication cancelled");
      } else {
        throw error;
      }
    }
  }

  public async logout(event: Event) {
    await WebAPI.logout();
    this.$store.commit(SET_USER_PROFILE, null);
    this.$router.push({ name: "home" });
  }

  public clearLoginForm() {
    this.login_form_username = "";
    this.login_form_password = "";
  }
}
